// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  version: "Dev-1.0.0",
  endpoint : "https://dev-virtualracesfrance-api.herokuapp.com/api",
  paypal: "Ab5Io2tvu4h0yoGC2qvU4LuHVc-6qXDafjEWbOgvNldybuaxFqHpGqYrz2dDXLOFZJDh_O4bsJCn6968",
  stripe: "pk_test_iN5N3PdK7LIxe3gu8vOjCgZv00cdFRNyHg",
  stripePriceUs: "price_1GpheFJOioj7ZC2tu77oHa8X",
  stripePriceFr: "price_1GphdjJOioj7ZC2tYbaK3ROF",
  stripePriceCa: "price_1GphdsJOioj7ZC2tLc4UACTq"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
